import axios from "axios";
import requestInterceptor from "./requestInterceptor";
import responseInterceptorSuccess from "./responseInterceptorSuccess";
import responseInterceptorFailure from "./responseInterceptorFailure";
import { getStoredAccessToken } from "../../utils/regBranchOnLoadPayload";
import {
    TIMEOUT,
    BASE_URL,
    PARAM_SERIALIZER,
} from "./defaultConstants";

// setting axios initial default config
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = BASE_URL;
axios.defaults.paramsSerializer = PARAM_SERIALIZER;

/** Sync defaults for anything that reads axios.defaults outside a request; each request also sets Authorization in requestInterceptor. */
const initialToken = getStoredAccessToken();
if (initialToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${initialToken}`;
}

// request interceptor
axios.interceptors.request.use(requestInterceptor);

// response interceptor
axios.interceptors.response.use(
    responseInterceptorSuccess,
    responseInterceptorFailure
);

export default axios;
